import React, { useEffect } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const Violations = () => {
  const { t } = useLocalize()
  const { data, setData } = useRaportForm()

  useEffect(() => {
    setData((prev: any) => ({
      printDayActivities: true,
      printDayNotes: true,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
      ...prev,
    }))
  }, [])

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <CheckboxWithLabelField
            field="printDayActivities"
            data={data}
            setData={setData}
            label={t('printout.print-day-activities')}
          />
          <CheckboxWithLabelField
            field="printDayNotes"
            data={data}
            setData={setData}
            label={t('printout.print-annotations')}
          />
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
      />
    </div>
  )
}

export default Violations
